import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Profile } from 'src/app/models/profile.model';
import { BehaviorSubject } from 'rxjs';
import { storageKeys } from 'src/app/enum/storage-keys';

export class AuthUserId{
  constructor(public uid: string){}
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _uid = new BehaviorSubject<AuthUserId>(null);

  constructor(
    private storage: StorageService,
    private fireAuth: AngularFireAuth,
    private adb: AngularFirestore
  ) { }


  async getId(){
    const user = this._uid.value;
    if(user?.uid) {
      return user.uid;
    } else {
      return (await this.storage.getStorage(storageKeys.UID)).value;
    }
  }

  async setUserDataLocally(uid: string){
    this.storage.setStorage(storageKeys.UID, uid);
    this._uid.next(new AuthUserId(uid));
  }

  async setUserDataFirestor(_user: Profile){
    let user: any = Object.assign({}, _user);
    Object.keys(user).forEach(key => {
      if (
        user[key] === undefined ||
        user[key] === '' ||
        user[key] === null
      ) delete user[key];
    });



    try{
      await this.adb.collection('users').doc(user.uid).set(user);
    } catch(e) {
      throw(e);
    }
  }


  async updateNotificationToken(uid: string, tokenString: string){
    try {
      await this.adb.collection('users').doc(uid).update({
        'notification_token' : tokenString
      });
    } catch (e) {
      throw (e);
    }
  }

  async isUserExist(id: string): Promise<boolean>{
    const data = this.adb.collection('users').doc(id).ref;
    return data.get().then(doc => {
      if (doc.exists) return true;
      else return false;
      }
    ).catch(e => {throw(e);});
  }

  checkAuth(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.fireAuth.onAuthStateChanged(user => {
        if(user) {
          this.setUserDataLocally(user.uid);
          resolve(user.uid);
        } else {
          this.logout();
          reject(false);
        }
      });
    });
  }

  async register(email: string, password: string){
    return await this.fireAuth.createUserWithEmailAndPassword(email, password).then(res => {
      return res.user.uid;
    }).catch(e => {
      throw(e);
    });
  }

  async login(email: string, password: string): Promise<any>{
    try{
      const reponse = await this.fireAuth.signInWithEmailAndPassword(email, password);
      if(reponse.user) return reponse.user.uid;
    } catch(e) {
      throw(e);
    }
  }

  async resetPassword(email: string){
    try {
      await this.fireAuth.sendPasswordResetEmail(email);
    } catch(e) {
      throw(e);
    }
  }

  async signInWithCredential(credential){
    try {
      return this.fireAuth.signInWithCredential(credential);
    } catch(e) {
      console.log(e);
      throw(e);
    }
  }

  async signInWithPhoneNumber(phoneNumber ,recaptchaVerifier){
    try {
      return await this.fireAuth.signInWithPhoneNumber(phoneNumber, recaptchaVerifier);
    } catch(e) {
      throw(e);
    }
  }

  async logout(){
    try{
      await this.adb.collection('users').doc(await this.getId()).update({
        'notification_token' : null
      });
      await this.fireAuth.signOut();
      this._uid.next(null);
      return this.storage.removeStorage(storageKeys.UID);
    }  catch(e) {
      throw(e);
    }

  }

  async deleteAccountAuth(){
    try{
      await (await this.fireAuth.currentUser).delete();
      await this.fireAuth.signOut();
      this.storage.removeStorage(storageKeys.UID);
    }catch(e){
      console.log(e);
      throw(e);
    }
  }

}
